import React from 'react';
import { getTierNotchGlowStyle } from './VideoBadgeProgress';
import './PricingPage.css';
import './HomeSignedInIdleShell.css';

/**
 * Top-only pricing-style band for signed-in idle home:
 * hero bg + rounded white notch. Badge sits in the hero;
 * page content below is unchanged.
 */
export default function HomeSignedInIdleShell({ badge, children, tierKey = 'none' }) {
  return (
    <div className="home-signed-in-shell">
      <div className="home-signed-in-top">
        <div className="home-signed-in-top-bg" />
        <div className="home-signed-in-top-badge">
          {badge}
        </div>
      </div>
      <div className="home-signed-in-notch-outer" style={getTierNotchGlowStyle(tierKey)}>
        <div className="home-signed-in-notch">
          {children}
        </div>
      </div>
    </div>
  );
}
